import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
// Secciones
import { InicioComponent } from './inicio/inicio.component';
import { NuestrosServiciosComponent } from './nuestros-servicios/nuestros-servicios.component';
import { QuienesSomosComponent } from './quienes-somos/quienes-somos.component';
import { ClientesComponent } from './clientes/clientes.component';
import { ContactanosComponent } from './contactanos/contactanos.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';

const routes: Routes = [
  { path: '', component: InicioComponent },
  { path: 'inicio', component: InicioComponent },
  { path: 'nuestros-servicios', component: NuestrosServiciosComponent },
  { path: 'quienes-somos', component: QuienesSomosComponent },
  { path: 'clientes', component: ClientesComponent },
  { path: 'contactanos', component: ContactanosComponent },
  { path: '**', component: InicioComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  declarations: [],
  exports: [RouterModule]
})

export class RoutingModule { }



// WEBPACK FOOTER //
// ./src/app/routing.module.ts